// @flow
import has from 'lodash/has';

export default function sortImagesByPreferredSize(
  images: Array<Object>,
  preferredSize: number
): Array<Object> {
  if (images == null || !images.length) {
    return images;
  }

  return images.sort((a, b) => {
    const aHasPreferredImage = has(a, `${preferredSize}`);
    const bHasPreferredImage = has(b, `${preferredSize}`);

    if (aHasPreferredImage && !bHasPreferredImage) {
      return -1;
    }
    if (!aHasPreferredImage && bHasPreferredImage) {
      return 1;
    }
    return 0;
  });
}



// WEBPACK FOOTER //
// ./app/components/shared/Images/Image/utils/sortImagesByPreferredSize.js